import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { DynamicFormComponent } from 'app/_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { ContractorService } from 'app/_services/contractor.service';

@Component({
  selector: 'app-contractor-workers',
  templateUrl: './contractor-workers.component.html',
})
export class ContractorWorkersComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  users: any[] = [];
  selectedUser: any;
  tabitems: any[] = [];

  selectedContractor: any;
  selectedContractorId: any;

  sidebarVisible = false;
  createUserModal = false;
  createUserForm: FormGroup;

  pageSizes: any = environment.pageSizes;
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  selectedSort: any;

  sortFields: any[] = [
    {
      sortName: 'First Name (asc)',
      sortString: 'user.firstName,asc',
    },
    {
      sortName: 'First Name (desc)',
      sortString: 'user.firstName,desc',
    },
    {
      sortName: 'Last Name (asc)',
      sortString: 'user.lastName,asc',
    },
    {
      sortName: 'Last Name (desc)',
      sortString: 'user.lastName,desc',
    },
  ];

  role: any;
  routeRole: any;

  errorAlerts: any[] = [];

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public contractorService: ContractorService,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedContractorId = params.id;
    });

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/contractors/', title: 'All Contractors', class: 'back-link' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/details', title: 'Details' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/workers', title: 'Workers' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/certificates', title: 'Certificates' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/contacts', title: 'Contacts' },
    ];

    this.createUserForm = fb.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required]),
      pin: new FormControl('', [Validators.required]),
      rPin: new FormControl('', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required, Validators.minLength(8)]),
    });

    this.selectedSort = this.sortFields[0];
  }

  ngOnInit() {
    this.resetPagination();
    this.getAllContractorWorkers();
    this.getSelectedContractorCompany(this.selectedContractorId);
  }

  public getSelectedContractorCompany(id) {
    this.contractorService.getContractorById(id).subscribe((data: any) => {
      this.selectedContractor = data;
      if(this.selectedContractor.oem){
        this.tabitems.push({ path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/procedures', title: 'Procedures' })
      }
    });
  }

  public getAllContractorWorkers() {
    this.contractorService.getAllWorkersForContractor(this.selectedContractorId, this.pagination, this.selectedSort.sortString).subscribe((data: any) => {
      this.users = data.body;

      this.users.forEach(worker => {
        worker.isSiteDelegate = worker.authorities.some((authority) => authority.name === 'ROLE_SITE_DELEGATE');
      });
      this.pagination.totalRecords = data.totalRecords;
    });
  }


  /* PAGINATION */
  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;

    this.getAllContractorWorkers();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
  /* PAGINATION END */

  // toggle the create user modal
  public toggleAddWorkerModal() {
    this.createUserModal = !this.createUserModal;
  }

  // create user, reset forms, toggle modal, reload data
  public onCreateUserFormSubmit() {
    this.clearErrors();
    const values = this.createUserForm.value;
    if (values.pin === values.rPin) {
      const body = {
        email: values.email.trim(),
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
        pin: values.pin,
        phoneNumber: values.phoneNumber.trim(),
        maintenanceId: this.selectedContractorId,
        workOrderAdmin: false,
      };
      this.contractorService.createWorker(body).subscribe((data: any) => {
        this.toggleAddWorkerModal();
        this.createUserForm.reset();
        this.resetPagination();
        this.getAllContractorWorkers();
        Swal.fire('Success', 'Contractor Worker Created!', 'success');
      }, error => {
        console.log('error', error);
        if (error.error && error.error.title) {
          if (error.error.fieldErrors && error.error.fieldErrors.length > 0 && error.error.title === 'Method argument not valid') {
            this.errorAlerts.push({ severity: 'error', summary: 'Invalid field entry: ' + error.error.fieldErrors[0].field});
          } else {
            this.errorAlerts.push({ severity: 'error', summary: error.error.title });
          }
        } else {
          throw error;
        }

      });
    } else {
      this.errorAlerts.push({ severity: 'error', summary: 'Passwords do not match!' });
    }
  }

  public clearErrors() {
    this.errorAlerts = [];
  }

  public async onRowSelect(event) {
    this.selectedUser = event.data;

    this.router.navigate(['/', this.routeRole, 'workers', this.selectedUser.id, 'details'],
      { queryParams: { backLink: `/${this.routeRole}/contractors/${this.selectedContractorId}/workers` } }
    );
  }

  public sortChange(event) {
    this.selectedSort = event;
    this.goToFirstPage();
    this.getAllContractorWorkers();
  }
}
